import IfRouterOpen from '../../hook/IfRouterOpen';


const Aboutconcept = () => {
   const routerOpen = IfRouterOpen()

   return (
      <div className='About-concept flexCenter'>
         <img src={require("../../img/about3.jpg")} alt="" style={{ transform: `translateY(${routerOpen ? '0px' : '500px'})` }}/>
         <div style={{ transform: `translateY(${routerOpen ? '0px' : '500px'})` }}>
            <h1>Story of Stories</h1>
            <span>‘이야기 속의 이야기’</span>
            <p>LCDC SEOUL은 “LE CONTE DES CONTES 이야기 속의 이야기”의 앞 글자 LCDC를 따 왔으며, 다양한 이야기를 가진 브랜드가 모여 새로운 이야기를 만들어내는 공간입니다. 여러 단편 소설들이 모여 하나의 단편집을 이루듯, 크고 작은 독립적인 브랜드가 서로 협력하여 만든 각자의 이야기는 하나의 이야기로 펼쳐집니다. 이는 기존의 복합 공간을 넘어 각 브랜드의 장점을 극대화해줄 수 있는 탄탄한 컨셉과 구조 속에서 운영됩니다.</p>
            <p>“Le Conte Des Contes”는 시인 잠 바티스타 바 실레(Giambattista Basile)에 의해 수집된 이야기책 펜타메론(Pentamerone)의 다른 이름입니다. 이 책은 최초의 이야기 모음집으로 5챕터의 각각 10가지 이야기를 모아 총 50가지의 다른 이야기들이 담겨있습니다. 이는 하나의 큰 맥락의 프레임을 가지고 그 안에서 모두 다른 주제와 모티프를 가지고 이야기가 전개됩니다.</p>
            <p>LCDC SEOUL 공간을 이루는 복합적인 감각은 균형과 조화를 이루며, 감도 높은 경험을 제공합니다. 공간을 찾는 이들은 자연스럽게, 또 분명하게 드러나는 감각들을 통해 주목할 만한 가치 를 발견할 것입니다.</p>
         </div>

         
      </div>
   );
};

export default Aboutconcept;